// EstimateBudgetIntro Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget as dropTarget } from 'react-dnd'
import classnames from 'classnames'

import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'

const budgetIntroTarget = {
  drop (props, monitor) {
    const item = monitor.getItem()

    if (item && item.type === 'text') {
      if (props.onUpdate) {
        props.onUpdate(item.title)
      }

      if (props.onDeleteActivity) {
        props.onDeleteActivity(item)
      }
    }
  }
}

@dropTarget((_props) => 'all', budgetIntroTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
class EstimateBudgetIntro extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active,
      editable: false
    }

    this._references = {
      editor: React.createRef()
    }
  }

  static get propTypes () {
    return {
      introText: PropTypes.string,
      onUpdate: PropTypes.func,
      onDeleteActivity: PropTypes.func,
      connectDropTarget: PropTypes.func,
      active: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      introText: null,
      onUpdate: null,
      onDeleteActivity: null,
      connectDropTarget: null,
      active: false
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._references.editor.current &&
      prevState.editable !== this.state.editable &&
      this.state.editable
    ) {
      this._references.editor.current.focus()
    }
  }

  show (bEditable) {
    this.setState({ active: true, editable: bEditable })
  }

  hide () {
    this.setState({ active: false, editable: false })
  }

  render () {
    const { connectDropTarget, introText } = this.props
    const active = this.state.active
    const className = classnames('estimatebudget-intro', {
      active
    })

    return connectDropTarget(
      <div className={className}>
        <div className='content'>
          {this.state.editable ? (
            <form method='post' noValidate action='#'>
              <WysiwygEditor
                ref={this._references.editor}
                placeholder='project.viewBudget.placeholderIntro'
                inlineEditor={false}
                value={introText}
                className='wysiwygtypo'
                onBlur={this._onBlur.bind(this)}
              />
            </form>
          ) : (
            <div
              className='wysiwygtypo margin-adjust cursor-pointer'
              onClick={this._onEdit.bind(this)}
            >
              <FroalaEditorView model={introText} />
            </div>
          )}
        </div>
        <IconButton
          icon='common-item-delete'
          title='project.viewBudget.removeIntro'
          canHover={false}
          size='small'
          className='purchaseview'
          onClick={this._onDelete.bind(this)}
        />
      </div>
    )
  }

  /* Private functions */
  _onBlur (value, _ev) {
    if (this.props.onUpdate) {
      this.props.onUpdate(value)
    }
    this.setState({ editable: false })
  }

  _onDelete (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onUpdate) {
      this.props.onUpdate('')
    }

    this.hide()
  }

  _onEdit () {
    this.setState({ editable: true })
  }
}

export default EstimateBudgetIntro
